import { styled, makeResponsive, Responsive } from '../../design-system'
import { Box, BoxProps } from '../../design-system'
import { spacingLevel } from '../../design-system'
import {
  AlignContentProperty,
  JustifyItemsProperty,
  AlignItemsProperty,
  JustifyContentProperty,
} from 'csstype'
import css from '@emotion/css'

const px = (x: string | number) => (typeof x === 'number' ? x + 'px' : x)
const responsive = makeResponsive<PartnerGridProps>()

export interface PartnerGridProps extends BoxProps {
  gap?: number
  columnSize?: Responsive<number>
  fillMode?: 'auto-fill' | 'auto-fit'
  maxColumnSize?: number | string
  justifyItems?: JustifyItemsProperty
  alignItems?: AlignItemsProperty
  justifyContent?: JustifyContentProperty
  alignContent?: AlignContentProperty
}

export const PartnerGrid = styled(Box)<PartnerGridProps>`
  display: grid;
  ${responsive(
    'columnSize',
    (columnSize, { fillMode = 'auto-fit', maxColumnSize }) => `repeat(
      ${fillMode},
      minmax(
        ${columnSize}px,
        ${maxColumnSize ? px(maxColumnSize) : '1fr'}
      )
    );`,
    'grid-template-columns',
  )}
  grid-gap: ${({ gap = 3 }) => spacingLevel(gap)}px;
  justify-items: ${({ justifyItems = 'center' }) => justifyItems};
  align-items: ${({ alignItems = 'center' }) => alignItems};
  justify-content: ${({ justifyContent = 'center' }) => justifyContent};
  align-content: ${({ alignContent = 'start' }) => alignContent};
`
